// tslint:disable:max-line-length
import * as React from "react";
import { iconStyle } from './icon.style';
interface IProps {
  style?: React.CSSProperties;
}
export const DotsIcon: React.FC<IProps> = (props) =><svg id="icons" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style={{...iconStyle, ...props.style}}>
  <path d="M13.88,12c0,1.03-.84,1.88-1.88,1.88s-1.88-.84-1.88-1.88.84-1.88,1.88-1.88,1.88.84,1.88,1.88ZM12,6.88c1.03,0,1.88-.84,1.88-1.88s-.84-1.88-1.88-1.88-1.88.84-1.88,1.88.84,1.88,1.88,1.88ZM12,17.12c-1.03,0-1.88.84-1.88,1.88s.84,1.88,1.88,1.88,1.88-.84,1.88-1.88-.84-1.88-1.88-1.88Z"/>
</svg>


// WEBPACK FOOTER //
// ./src/icons/Dots.tsx